import React from "react";
import _ from "underscore";

import Button from "@material-ui/core/Button";

import RenderOfferWithButtonCmp from "./RenderOfferWithButtonCmp";
import { OfferStyle } from "./helper";

const CreditOffersComponent = ({
  creditOffers,
  rejectCreditApplication,
  applicationId,
  approveRejectCreditOffers,
}) => {
  const sortedOffers = _.sortBy(creditOffers, (offers) => {
    return offers.PayoutAmount;
  });

  return (
    <React.Fragment>
      <div key={"offerDecline"} style={OfferStyle.Borderless}>
        <Button
          className="approveReject"
          variant="contained"
          color="primary"
          style={{ marginLeft: "2px" }}
          onClick={() => rejectCreditApplication(applicationId)}
        >
          Decline all
        </Button>
      </div>
      {creditOffers && creditOffers.length
        ? sortedOffers.map((offerWithDecision, index) => (
            // eslint-disable-next-line react/jsx-key
            <RenderOfferWithButtonCmp
              {...{ offerWithDecision, index, applicationId }}
              approveRejectCreditOffers={approveRejectCreditOffers}
            />
          ))
        : "No credit offers"}
    </React.Fragment>
  );
};

export default CreditOffersComponent;
